<template>
    <date-range-picker
        :date-range="model"
        opens="right"
        :ranges="ranges"
        :min-date="minDate"
        :max-date="maxDate"
        @start-selection="updateDateBounds"
        @finish-selection="clearDateBounds"
        @update="update"
    />
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import mutableDate from 'lib/mutableDate';

const today = new Date
today.setHours(0, 0, 0, 0)

const ranges  = {
    Today: [today, today],
    'This Month': [
        mutableDate(today).setDate(1).toDate(),
        mutableDate(today).setMonth(today.getMonth()+1).setDate(0).toDate()
    ],
    'Last 30 Days': [
        mutableDate(today).setDate(today.getDate() - 30).toDate(),
        today
    ],
    'Last 90 Days': [
        mutableDate(today).setDate(today.getDate() - 90).toDate(),
        today
    ],
}

export default {
    props: {
        value: {
            type: Object,
            default: () => ({
                startDate: ranges['Last 30 Days'][0],
                endDate: ranges['Last 30 Days'][1]
            }),
        },
    },
    components: {
        DateRangePicker,
    },
    data() {
        return {
            model: this.value,
            ranges,
            minDate: null,
            maxDate: null,
        }
    },

    methods: {
        updateDateBounds(start) {
            this.minDate = mutableDate(start).setDate(start.getDate() - 90).toDate()
            this.maxDate = mutableDate(start).setDate(start.getDate() + 90).toDate()
        },
        clearDateBounds() {
            this.minDate = null
            this.maxDate = null
        },
        update(value) {
            this.$emit('input', value)
        },
    },
}
</script>
<style>
.calendar-table table th {
    color: inherit;
}
</style>
